import React from 'react';
import * as DesktopFiltersGoogleAnalytics from '../../_modules/google_analytics/catalog/desktop_filters';
import CatalogFilterViewStore from '../../_flux/stores/catalog_filter_view_store';
import CatalogTyreFilterStore from '../../_flux/stores/catalog_filter_store/tyre';
import {getCatalogFilterOptionsStoreByProductType} from '../../_flux/stores/catalog_filter_options_store/factory';
import {FilterAvailableOptionsStore} from '../../_flux/stores/filter_available_options_store';
import CatalogConditionalFiltersStore from '../../_flux/stores/catalog_conditional_options_store';
import {Tyre} from '../../_flux/components/catalog_filters/filters_column/tyre';
import {handleView} from '../handle_view';
import {onFilterChange, onActionClick, onVehicleTyreFilterChange, onRegoLookupEdit, onVehicleSelectorEdit} from './common';
import LastUsedConfiguratorStore from '../../_flux/stores/last_used_configurator_store';
import {onShowVehicleInfo} from './on_show_vehicle_info';

const stores = {
    catalogFilterViewState: CatalogFilterViewStore,
    catalogFilterState: CatalogTyreFilterStore,
    filterAvailableOptionsState: FilterAvailableOptionsStore,
    catalogConditionalFiltersState: CatalogConditionalFiltersStore,
};

const render = (
    {
        catalogFilterViewState,
        catalogFilterState: filterValues,
        filterOptionsState: filterOptions,
        filterAvailableOptionsState: availableFilterOptions,
        catalogConditionalFiltersState: conditionalFilters,
    },
    options
) => (
    <Tyre
        visible={catalogFilterViewState.visible}
        sectionVisibility={catalogFilterViewState.sectionVisibility}
        filterValues={filterValues}
        filterOptions={filterOptions}
        availableFilterOptions={availableFilterOptions}
        conditionalFilters={conditionalFilters}
        lastUsedConfigurator={LastUsedConfiguratorStore.getState().configuratorSource}
        currencyIsoCode={options.currencyIsoCode}
        onActionClick={options.onActionClick}
        onToolTipHover={DesktopFiltersGoogleAnalytics.showToolTipAction}
        onChangeCallback={options.onFilterChange}
        onVehicleTyreChange={options.onVehicleTyreChange}
        onRegoLookupEdit={onRegoLookupEdit}
        onVehicleSelectorEdit={onVehicleSelectorEdit}
        onShowVehicleInfo={onShowVehicleInfo}
    />
);

const getOptions = options => ({
    ...options,
    onFilterChange: onFilterChange(options.currencyIsoCode, options.productType),
    onActionClick: onActionClick(options.productType),
    onVehicleTyreChange: onVehicleTyreFilterChange(options.productType),
});

export const init = (container, options) => {
    stores.filterOptionsState = getCatalogFilterOptionsStoreByProductType(options.productType);

    return handleView(stores, render, getOptions(options), container);
};

